import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '@/containers/Full.vue';

// Views
import Login from '@/views/admin/Login.vue';
import Acl from '@/views/admin/Acl.vue';
import Translator from '@/views/admin/Translator.vue';
import Languages from '@/views/admin/Languages.vue';
import SiteProps from '@/views/admin/SiteProps.vue';
import EmailTemplates from '@/views/admin/EmailTemplates.vue';
// import UserCompanies from '@/views/admin/UserCompanies.vue';
import CompanyType from '@/views/admin/CompanyType.vue';
import Users from '@/views/admin/Users.vue';

import UserCompanies from '@/views/user_companies/Win.vue';

import Dashboard from '@/views/dashboard/private_dashboard/Dashboard.vue';
import DashboardKindergarten from '@/views/dashboard/kindergarten_dashboard/Dashboard.vue';

import Child from '@/views/child/Win.vue';
import ChildDetails from '@/views/child/WinDetails.vue';
import Parents from '@/views/parents/Win.vue';

import ChildKindergarten from '@/views/child_kindergarten/Win.vue';
import ChildKindergartenDetails from '@/views/child_kindergarten/WinDetails.vue';

import EducationalGroup from '@/views/educational_group/Win.vue';
import ObjectName from '@/views/object_name/Win.vue';

import TherapyType from '@/views/therapytype/Win.vue';
import WorkType from '@/views/worktype/Win.vue';
import Diagnose from '@/views/diagnose/Win.vue';

import Educator from '@/views/educator/Win.vue';
import WaitingList from '@/views/child/waiting_list/Win.vue';

import Room from '@/views/room/Win.vue';
import Note from '@/views/note/Win.vue';
import Statistics from '@/views/statistics/Win.vue';
// GENERATORLASTITEM

Vue.use(Router);

export default new Router({
    routes:
  [
      {
          path: '/admin/dashboard',
          name: 'HOME',
          component: Full,
          children: [
              {
                  path: '',
                  name: 'DASHBOARD',
                  component: Dashboard,
              },
          ],
      },
      {
          path: '/admin/dashboardkindergarten',
          name: 'HOME',
          component: Full,
          children: [
              {
                  path: '',
                  name: 'DASHBOARDKINDERGARTEN',
                  component: DashboardKindergarten,
              },
          ],
      },
      {
          path: '/admin/children',
          name: 'CHILDREN',
          component: Full,
          children: [
              {
                  path: 'child',
                  name: 'CHILD',
                  component:
          {
              render(c)
              {
                  return c('router-view');
              },
          },
                  children: [
                      {
                          path: '',
                          name: 'CHILD',
                          component: Child,
                      },
                      {
                          path: 'childdetails/:childId',
                          name: 'CHILDDETAILS',
                          component: ChildDetails,
                      }],
              },
              {
                  path: 'parents',
                  name: 'PARENTS',
                  component: Parents,
              },
          ],
      },
      {
          path: '/admin/childkindergarten',
          name: 'CHILDREN',
          component: Full,
          children: [
              {
                  path: 'child',
                  name: 'CHILD',
                  component:
        {
            render(c)
            {
                return c('router-view');
            },
        },
                  children: [
                      {
                          path: '',
                          name: 'CHILDKINDERGARTEN',
                          component: ChildKindergarten,
                      },
                      {
                          path: 'childdetails/:childKindergartenId',
                          name: 'CHILDKINDERGARTENDETAILS',
                          component: ChildKindergartenDetails,
                      }],
              },
              {
                  path: 'parents',
                  name: 'PARENTS',
                  component: Parents,
              },
              {
                  path: 'waitinglist',
                  name: 'WAITINGLIST',
                  component: WaitingList,
              },
          ],
      },
      {
          path: '/admin/struktur',
          name: 'THERAPY',
          component: Full,
          children: [
              {
                  path: 'educator',
                  name: 'EDUCATOR',
                  component: Educator,
              },
              {
                  path: 'educationalgroup',
                  name: 'EDUCATIONALGROUP',
                  component: EducationalGroup,
              },
              {
                  path: 'objectname',
                  name: 'OBJECTNAME',
                  component: ObjectName,
              },
          ],
      },
      {
          path: '/admin/therapy',
          name: 'THERAPY',
          component: Full,
          children: [
              {
                  path: 'therapytype',
                  name: 'THERAPYTYPE',
                  component: TherapyType,
              },
              {
                  path: 'worktype',
                  name: 'WORKTYPE',
                  component: WorkType,
              },
              {
                  path: 'diagnose',
                  name: 'DIAGNOSE',
                  component: Diagnose,
              },
          ],
      },
      {
          path: '/admin/room',
          name: 'HOME',
          component: Full,
          children: [
              {
                  path: '',
                  name: 'ROOM',
                  component: Room,
              },
          ],
      },
      {
          path: '/admin/statistics',
          name: 'HOME',
          component: Full,
          children: [
              {
                  path: '',
                  name: 'STATISTICS',
                  component: Statistics,
              },
          ],
      },
      {
        path: '/admin/note',
        name: 'HOME',
        component: Full,
        children: [
            {
              path: '',
              name: 'NOTE',
              component: Note,
          },
        ],
    },
      {
          path: '/admin/system',
          name: 'SYSTEM',
          component: Full,
          children: [
              {
                  path: 'acl',
                  name: 'ACL',
                  component: Acl,
              },
              {
                  path: 'translator',
                  name: 'TRANSLATOR',
                  component: Translator,
              },
              {
                  path: 'languages',
                  name: 'LANGUAGES',
                  component: Languages,
              },
              {
                  path: 'siteprops',
                  name: 'SITEPROPS',
                  component: SiteProps,
              },
              {
                  path: 'emailtemplates',
                  name: 'EMAILTEMPLATES',
                  component: EmailTemplates,
              },
              {
                  path: 'usercompanies',
                  name: 'USERCOMPANIES',
                  component: UserCompanies,
              },
              {
                  path: 'companytype',
                  name: 'COMPANYTYPE',
                  component: CompanyType,
              },
              {
                  path: 'users',
                  name: 'USERS',
                  component: Users,
              },
          ],
      },
      {
          path: '/admin',
          name: 'LOGIN',
          component: Login,
      },
  ],
});
